import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { useStore } from "@/store";
import { MutationType } from "@/models/storeModel";
import { IInputMethods } from "@/models/inputModel";


export default /*#__PURE__*/_defineComponent({
  emits: ["wrapImageInCanvas"],
  setup(__props, { expose, emit }: { emit: ({
  (e: "wrapImageInCanvas", file: Blob): void;
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const inputRef = ref<HTMLInputElement | null>(null);



const triggerInput = () => {
  if (inputRef.value) {
    inputRef.value.click();
  }
};

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const blob: File = (target.files as FileList)[0];
  store.commit(MutationType.SetImage, blob);
  emit("wrapImageInCanvas", blob);
};

const handleDrop = (event: DragEvent) => {
  event.preventDefault();
  const blob: File | undefined = event.dataTransfer?.files[0];
  if (blob) {
    store.commit(MutationType.SetImage, blob);
    emit("wrapImageInCanvas", blob);
  }
  (event.target as HTMLInputElement).classList.remove('on-drag');
};

const handleDragOver = (event: Event) => {
  event.preventDefault();
};

const handleDragEnter = (event: Event) => {
  const target = event.target as HTMLInputElement;
  target.classList.add('on-drag');
};

const handleDragLeave = (event: Event) => {
  const target = event.target as HTMLInputElement;
  target.classList.remove('on-drag');
};

expose<IInputMethods>({
  inputRef,
  handleInput,
  triggerInput,
  handleDrop,
  handleDragOver,
  handleDragEnter,
  handleDragLeave,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    class: "input",
    name: "myFile",
    type: "file",
    ref_key: "inputRef",
    ref: inputRef,
    onChange: handleInput
  }, null, 544))
}
}

})